(function(){
"use strict";

var r=document.querySelector("[data-ptiq-mission-root]");
if(!r){return;}

/*
  Founder IQ canonical storage keys.
  These must match the Founder IQ dashboard exactly.
*/
var EVENTS_KEY="pretrip_founder_iq_events_v1";
var SUMMARY_KEY="pretrip_founder_iq_summary_v1";
var SESSION_KEY="pretrip_founder_iq_session_v1";

/*
  Legacy keys are still written for backward compatibility.
*/
var LEGACY_EVENTS_KEY="ptiq_founder_iq_events_v1";
var LEGACY_SUMMARY_KEY="ptiq_founder_iq_summary_v1";

var p=new URLSearchParams(location.search);
var d=Math.max(1,Math.min(21,Number(p.get("day")||1)));
var openedAt=Date.now();
var lastProgress=-1;
var missionDone=false;
var paywallShown=false;

function getJSON(key,fallback){
  try{
    var value=JSON.parse(localStorage.getItem(key)||"");
    return value==null?fallback:value;
  }catch(e){
    return fallback;
  }
}

function setJSON(key,value){
  try{
    localStorage.setItem(key,JSON.stringify(value));
  }catch(e){}
}

function sessionId(){
  var value="";
  try{
    value=sessionStorage.getItem(SESSION_KEY)||"";
  }catch(e){}

  if(!value){
    value="mission_"+Date.now()+"_"+Math.random().toString(36).slice(2,9);
    try{
      sessionStorage.setItem(SESSION_KEY,value);
    }catch(e2){}
  }

  return value;
}

function categoryFor(name){
  name=String(name||"").toLowerCase();

  if(/paywall|upgrade|purchase|restore|subscription/.test(name)){
    return "revenue";
  }

  if(/voice|microphone|speech/.test(name)){
    return "voice_coach";
  }

  if(/quiz|score|assessment|test/.test(name)){
    return "assessment";
  }

  if(/failed|error|unavailable/.test(name)){
    return "reliability";
  }

  return "training_funnel";
}

function canonicalName(name,properties){
  var stepId=String(properties&&properties.step_id||"");

  if(name==="pretrip_mission_opened"){
    return "student_opened";
  }

  if(name==="pretrip_mission_start_tapped"){
    return "study_started";
  }

  if(name==="pretrip_voice_attempt_started"){
    return "voice_started";
  }

  if(name==="pretrip_voice_completed"){
    return "voice_completed";
  }

  if(name==="pretrip_voice_skipped"){
    return "voice_completed";
  }

  if(name==="pretrip_mission_step_completed"&&stepId==="voice"){
    return "voice_completed";
  }

  if(name==="pretrip_mission_completed"){
    return "mission_completed";
  }

  if(name==="pretrip_quiz_submitted"&&Number(properties&&properties.passed||0)===1){
    return "practice_test_completed";
  }

  if(name==="pretrip_mission_paywall_shown"){
    return "upgrade_viewed";
  }

  if(name==="pretrip_mission_upgrade_tapped"){
    return "upgrade_tapped";
  }

  if(name==="pretrip_parts_iq_from_mission_tapped"){
    return "parts_started";
  }

  return name;
}

function eventLabel(name){
  var labels={
    student_opened:"Student opened app",
    study_started:"Study session started",
    voice_started:"Voice Coach started",
    voice_completed:"Voice Coach completed",
    mission_completed:"Mission completed",
    practice_test_completed:"Practice test completed",
    upgrade_viewed:"Upgrade viewed",
    upgrade_tapped:"Upgrade tapped",
    parts_started:"Parts IQ started"
  };

  return labels[name]||String(name||"").replace(/_/g," ");
}

function appendUnique(list,event){
  if(!Array.isArray(list)){
    list=[];
  }

  var exists=list.some(function(item){
    return item&&item.id===event.id;
  });

  if(!exists){
    list.unshift(event);
  }

  var cutoff=Date.now()-(35*24*60*60*1000);

  return list.filter(function(item){
    return Number(item&&item.at||0)>=cutoff;
  }).slice(0,2500);
}

function updateLegacyFounderState(event){
  var key="pretrip_founder_iq_v1";
  var state=getJSON(key,{});

  if(!state||typeof state!=="object"||Array.isArray(state)){
    state={};
  }

  var name=event.event;
  state[name]=Number(state[name]||0)+1;

  if(name==="voice_completed"&&isFinite(Number(event.payload&&event.payload.score))){
    state.voice_score_total=
      Number(state.voice_score_total||0)+Number(event.payload.score);

    state.voice_score_count=
      Number(state.voice_score_count||0)+1;
  }

  if(!Array.isArray(state.activity)){
    state.activity=[];
  }

  state.activity.unshift({
    id:event.id,
    event:name,
    label:eventLabel(name),
    detail:event.payload&&event.payload.detail
      ?String(event.payload.detail)
      :"",
    at:event.at
  });

  state.activity=state.activity.slice(0,20);
  state.updatedAt=event.at;

  setJSON(key,state);
}

function track(name,properties){
  properties=properties||{};

  var now=Date.now();
  var canonical=canonicalName(name,properties);
  var session=sessionId();

  var event={
    id:"evt_"+now+"_"+Math.random().toString(36).slice(2,9),
    app:"pretrip_iq",
    product:"Pre-Trip IQ",
    surface:"mission",
    page:"pre_trip_mission",

    /*
      Canonical fields used by the current Founder IQ dashboard.
    */
    event:canonical,
    eventName:canonical,
    occurredAt:new Date(now).toISOString(),
    at:now,
    sessionId:session,
    day:d,
    payload:Object.assign({
      day:d,
      sourceEvent:name,
      source:"mission_asset"
    },properties),

    /*
      Legacy aliases retained for any older tools.
    */
    schema_version:"founder_iq_event_v2",
    event_id:null,
    event_name:canonical,
    occurred_at:new Date(now).toISOString(),
    session_id:session,
    source:"mission_asset",
    category:categoryFor(canonical),
    properties:Object.assign({
      day:d,
      sourceEvent:name
    },properties)
  };

  event.event_id=event.id;

  var canonicalEvents=appendUnique(
    getJSON(EVENTS_KEY,[]),
    event
  );

  setJSON(EVENTS_KEY,canonicalEvents);

  /*
    Also write a compatible legacy copy so older code does not break.
  */
  var legacyEvents=getJSON(LEGACY_EVENTS_KEY,[]);
  if(!Array.isArray(legacyEvents)){
    legacyEvents=[];
  }

  legacyEvents.push(event);

  if(legacyEvents.length>500){
    legacyEvents=legacyEvents.slice(-500);
  }

  setJSON(LEGACY_EVENTS_KEY,legacyEvents);

  var summary=getJSON(SUMMARY_KEY,{
    app:"pretrip_iq",
    total_events:0,
    counts:{},
    categories:{}
  });

  summary.total_events=Number(summary.total_events||0)+1;
  summary.last_event_at=event.occurredAt;
  summary.last_event_name=canonical;
  summary.counts=summary.counts||{};
  summary.categories=summary.categories||{};
  summary.counts[canonical]=Number(summary.counts[canonical]||0)+1;
  summary.categories[event.category]=
    Number(summary.categories[event.category]||0)+1;

  setJSON(SUMMARY_KEY,summary);
  setJSON(LEGACY_SUMMARY_KEY,summary);

  updateLegacyFounderState(event);

  /*
    Update an open Founder IQ page immediately when it exists
    in the same browser context.
  */
  try{
    window.dispatchEvent(new CustomEvent("pretrip:founder-event",{
      detail:{
        event:canonical,
        payload:event.payload,
        record:event
      }
    }));
  }catch(e){}

  /*
    Preserve optional remote ingestion.
  */
  try{
    var endpoint=
      window.PRE_TRIP_IQ_FOUNDER_ENDPOINT||
      window.FOUNDER_IQ_EVENT_ENDPOINT||
      "https://pre-trip-founder-iq-api-85238371012.us-central1.run.app/events";

    if(endpoint&&window.fetch){
      fetch(endpoint,{
        method:"POST",
        mode:"cors",
        cache:"no-store",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(event),
        keepalive:true
      }).then(function(response){
        if(!response.ok){
          throw new Error("Founder IQ API returned "+response.status);
        }
        return response.json().catch(function(){return {};});
      }).then(function(result){
        try{
          window.dispatchEvent(new CustomEvent("pretrip:founder-uploaded",{
            detail:{event:canonical,id:result&&result.id||event.id}
          }));
        }catch(e2){}
      }).catch(function(error){
        console.error("Founder IQ upload failed:",error);
      });
    }
  }catch(e){
    console.error("Founder IQ upload setup failed:",e);
  }

  /*
    Preserve GA4 when available.
  */
  try{
    if(typeof window.gtag==="function"){
      window.gtag("event",canonical,{
        app_name:"pretrip_iq",
        mission_day:d,
        source_event:name
      });
    }
  }catch(e){}
}

function completedDays(){
  var list=getJSON("ptiq21_completed_days_v1",[]);
  return Array.isArray(list)?list.map(Number):[];
}

function missionState(){
  return getJSON("ptiq21_mission_"+d+"_steps_v2",{});
}

function inspect(){
  var percentNode=r.querySelector("[data-mission-percent]");
  var progress=percentNode
    ?parseInt(percentNode.textContent,10)||0
    :0;

  var completionPanel=r.querySelector("[data-completion-panel]");
  var paywallPanel=r.querySelector("[data-paywall-panel]");

  if(progress!==lastProgress){
    lastProgress=progress;

    track("pretrip_mission_progress_changed",{
      progress_percent:progress,
      completed_days:completedDays().length
    });
  }

  if(
    !missionDone&&
    completionPanel&&
    completionPanel.hidden===false&&
    progress>=100
  ){
    missionDone=true;

    track("pretrip_mission_completed",{
      duration_ms:Date.now()-openedAt,
      completed_days:completedDays().length,
      quiz_score:Number(missionState().quizScore||0),
      parts_score:Number(missionState().partsScore||0)
    });

    track("study_completed",{
      duration_ms:Date.now()-openedAt,
      completed_days:completedDays().length
    });
  }

  if(!paywallShown&&paywallPanel&&paywallPanel.hidden===false){
    paywallShown=true;

    track("pretrip_mission_paywall_shown",{
      completed_days:completedDays().length
    });
  }
}

track("pretrip_mission_opened",{
  completed_days:completedDays().length,
  previously_completed:completedDays().indexOf(d)>=0?1:0
});

r.addEventListener("click",function(e){
  var x=e.target.closest&&e.target.closest("button,a[href]");

  if(!x){
    return;
  }

  if(x.matches("[data-start-mission]")){
    track("pretrip_mission_start_tapped",{
      resumed:Object.keys(missionState()).length?1:0
    });
  }
  else if(x.matches("[data-mic-button]")){
    track("pretrip_voice_attempt_started",{
      speech_recognition_available:
        (window.SpeechRecognition||window.webkitSpeechRecognition)?1:0
    });
  }
  else if(x.matches("[data-skip-voice]")){
    track("pretrip_voice_skipped",{
      skipped:1,
      detail:"Voice drill completed without microphone"
    });
  }
  else if(x.matches("[data-complete-step]")){
    var stepId=String(x.getAttribute("data-complete-step")||"");

    track("pretrip_mission_step_completed",{
      step_id:stepId
    });

    /*
      Explicit voice completion event. This is what Founder IQ needs.
    */
    if(stepId==="voice"){
      track("pretrip_voice_completed",{
        skipped:0,
        detail:"Voice drill completed"
      });
    }

    setTimeout(inspect,60);
  }
  else if(x.tagName==="A"){
    var href=String(x.getAttribute("href")||"");
    var name="pretrip_mission_link_tapped";

    if(href.indexOf("pretrip-plus")>=0){
      name="pretrip_mission_upgrade_tapped";
    }
    else if(href.indexOf("cdl-curriculum-overview")>=0){
      name="pretrip_mission_dashboard_tapped";
    }
    else if(href.indexOf("parts-iq")>=0){
      name="pretrip_parts_iq_from_mission_tapped";
    }
    else if(href.indexOf("pre-trip-mission")>=0){
      name="pretrip_next_mission_tapped";
    }

    track(name,{href:href});
  }
},false);

r.addEventListener("submit",function(e){
  if(!e.target.matches("[data-quiz-form]")){
    return;
  }

  setTimeout(function(){
    var result=r.querySelector("[data-quiz-result]");
    var text=String(result&&result.textContent||"");
    var match=text.match(/scored\s+(\d+)\s+of\s+(\d+)/i);

    track("pretrip_quiz_submitted",{
      score:match?Number(match[1]):0,
      total:match?Number(match[2]):5,
      passed:text.toLowerCase().indexOf("passed")>=0?1:0,
      incomplete:text.toLowerCase().indexOf("answer every")>=0?1:0
    });

    inspect();
  },60);
},false);

if(window.MutationObserver){
  try{
    new MutationObserver(inspect).observe(r,{
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:["hidden","class","style"]
    });
  }catch(e){}
}

setTimeout(inspect,100);
setInterval(inspect,1500);

})();